import dayjs from "dayjs";
import { FC } from "react";
import { BoardingStatusCode, IDepartureBooking } from "../../interfaces/endpoints/IBoarding.types";
import Box from "../ui/Box";
import Status from "../ui/Status";

export const BOARDING_STATUS: Record<BoardingStatusCode, { name: string; type: "green" | "gray" | "orange" }> = {
  boarded: { name: "Skanuar", type: "green" },
  not_boarded: { name: "Pa skanuar", type: "gray" },
  no_show: { name: "Nuk u paraqit", type: "orange" }
};

export const namesOf = (booking: IDepartureBooking) =>
  booking.passengers.map((p) => `${p.firstName} ${p.lastName}`.trim()).join(", ");

export const bookedElsewhere = (booking: IDepartureBooking) =>
  !!booking.boardedTripId && booking.boardedTripId !== booking.bookedTripId;

// One booking on a phone: who, how many, and whether they are on the bus.
const PassengerCard: FC<{ booking: IDepartureBooking }> = ({ booking }) => (
  <Box>
    <p className="break-words font-semibold">{namesOf(booking) || booking.bookingReference}</p>
    <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-neutral">
      <Status {...BOARDING_STATUS[booking.statusCode]} />
      <span>
        {booking.bookingReference} · {booking.passengerCount}{" "}
        {booking.passengerCount === 1 ? "udhëtar" : "udhëtarë"}
      </span>
      {booking.boardedAt && <span>skanuar në {dayjs(booking.boardedAt).format("HH:mm")}</span>}
    </div>
    {bookedElsewhere(booking) && (
      <p className="mt-1 text-xs text-neutral">
        Rezervuar për {dayjs(booking.bookedDeparture).format("HH:mm")}
      </p>
    )}
  </Box>
);

export default PassengerCard;
